// extracted by mini-css-extract-plugin
export default {"icons":"PropertiesCard_icons__VoxTH","greyText":"PropertiesCard_greyText__uGz0C"};